import React, { useState } from 'react';
import { getAppFlow } from '../views/utils/app.utils';
import { APP_FLOW } from './constant';

const PageHeader = ({steps, title, subTitle, hideHeader = false}) => {
    const [isSkipButtonVisible, setIsSkipButtonVisible] = useState(true);
    const [btnText, setBtnText] = useState("Next");

    return (
        <>
            {!hideHeader ? <div className='page-header'>
                <div className='header-content'>
                    <h3> {title} </h3>
                    <h6> {subTitle}</h6>
                </div>
                <div className='header-step'>
                    <div className="circle-progress" style={{ "--progress": `${((steps / 7) * 100).toFixed(1)}` }}>
                        <p className="inner-text"> <span>{steps}</span> of 7</p>
                    </div>
                </div>
            </div> : null}
        </>
    );
};

export default PageHeader;